var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1C4.81286 1 1 4.81286 1 9.5C1 14.1871 4.81286 18 9.5 18C14.1871 18 18 14.1871 18 9.5C18 4.81286 14.1871 1 9.5 1ZM9.5 16.7857C5.48071 16.7857 2.21429 13.5193 2.21429 9.5C2.21429 5.48071 5.48071 2.21429 9.5 2.21429C13.5193 2.21429 16.7857 5.48071 16.7857 9.5C16.7857 13.5193 13.5193 16.7857 9.5 16.7857Z",
    fill: "#8E8A8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0742 6.06358L9.49992 8.63786L6.92563 6.06358C6.35492 5.49286 5.49884 6.35501 6.06956 6.91965L8.64384 9.49393L6.06956 12.0682C5.49884 12.6389 6.36706 13.4889 6.92563 12.9243L9.49992 10.35L12.0742 12.9243C12.6388 13.4889 13.501 12.6329 12.9303 12.0682L10.356 9.49393L12.9303 6.91965C13.501 6.34893 12.6388 5.49286 12.0742 6.06358Z",
    fill: "#8E8A8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/declineIcon.dbc4d42f9ef76db030f39deba495cb75.svg";
export { ForwardRef as ReactComponent };